
<template>
  <customModal
    :containerxxl="true"
    :bodyxl="true"
    :footerShow="false"
    @closeModal="closeeditecrfpopup()"
  >
    <!-- Modal Title -->
    <template #title>
      <h4 class="my-0">
        Edit eCRF Form
      </h4>
    </template>

    <template #body>
      <div class="ibox-content-edit">
        <div class="ibox-body">
<editForm
    :key="mappedCloseOption + '|' + formsid"
    :formsesid="formsid"
    :requiredsubmit="false"
    closeoption="dataEntry"
    :showtitlebar = "false"
    :isfieldvalidate="showpopup"
    :showsignlist="isshowsignlist"
    :isPatientVisit="isPatientVisit"
    :isecrfform="true"
  />

        </div>
      </div>
    </template>
  </customModal>
</template>

<script src="./editecrffrompopup.js"></script>

<style scoped>
.data-grid {
  margin-top: 20px;
}

.errormsg {
  color: red;
  font-size: 12px;
}
</style>
